import React from 'react';

class Toggle extends React.Component{
    render(){
        return (
            <div>
                <label className="m-r-half-pt">
                    <span className='text-gray m-b-half-pt'> <p>{this.props.caption}</p></span>
                </label>
                <label className="switch">
                    <input type="checkbox" checked={this.props.toggleState} onChange={this.props.toggleHandler} />
                    <span className="slider round"></span>
                </label>
            </div>
        );
    }
}
export default (Toggle);


// WEBPACK FOOTER //
// ./src/components/Toggle.js